import { render, staticRenderFns } from "./beneficiary-item.vue?vue&type=template&id=26eab460&scoped=true&"
import script from "./beneficiary-item.vue?vue&type=script&lang=js&"
export * from "./beneficiary-item.vue?vue&type=script&lang=js&"
import style0 from "./beneficiary-item.vue?vue&type=style&index=0&id=26eab460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eab460",
  null
  
)

export default component.exports